import React from 'react';
import { Icon } from '@chakra-ui/react';
import { LuNotebookPen } from 'react-icons/lu';
import { AppliedCorrectionOut } from '@/client';
import EvidenceTriggerButton from './EvidenceTriggerButton';

interface ChatResponseCorrectionsBadgeProps {
	/** Applied corrections that fed this answer — drives the trigger count. Empty means
	 * "nothing was used", not "unknown" (see docs/local/chat-feature.md §C1). */
	appliedCorrections: AppliedCorrectionOut[];
	onOpen: (trigger: HTMLButtonElement) => void;
	hideOnMobile?: boolean;
}

/** "N corrections" trigger for the applied-corrections evidence channel. */
const ChatResponseCorrectionsBadge: React.FC<ChatResponseCorrectionsBadgeProps> = (
	props: ChatResponseCorrectionsBadgeProps,
) => {
	const { appliedCorrections, onOpen, hideOnMobile = false } = props;
	const count = appliedCorrections.length;
	if (count === 0) return null;
	const triggerLabel = `${count} ${count === 1 ? 'correction' : 'corrections'}`;

	return (
		<EvidenceTriggerButton
			display={{ base: hideOnMobile ? 'none' : 'inline-flex', md: 'inline-flex' }}
			onClick={(event) => onOpen(event.currentTarget)}
		>
			<Icon as={LuNotebookPen} boxSize={4} />
			{triggerLabel}
		</EvidenceTriggerButton>
	);
};

export default ChatResponseCorrectionsBadge;
